import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { initialMessage, userMessage } from 'constants/ui.constants';
import { startOfYesterday } from 'date-fns';
import type { IBeneficiaryDashboardDateRange } from 'types/beneficiary-dashboard.types';

interface IDashboardFilters {
	manager: string;
	lead: string;
	dealer: string;
	currency: string;
	dealType: string;
	paymentType: string;
	company: string;
	datesRange: {
		startDate: Date;
		endDate: Date;
	};
}

interface IDashboardState {
	searchResults: any[] | null;
	error: userMessage;
	loading: boolean;
	filters: IDashboardFilters;
	beneficiaryDatesRange: IBeneficiaryDashboardDateRange;
}

const initialState: IDashboardState = {
	searchResults: null,
	error: initialMessage,
	loading: false,
	filters: {
		manager: '',
		lead: '',
		dealer: '',
		currency: '',
		dealType: '',
		company: '',
		paymentType: '',
		datesRange: {
			startDate: startOfYesterday(),
			endDate: new Date(),
		},
	},
	beneficiaryDatesRange: {
		startDate: startOfYesterday(),
		endDate: new Date(),
	},
};

export const dashboardSlice = createSlice({
	name: 'dashboard',
	initialState,
	reducers: {
		setSearchResults: (state, { payload }) => {
			state.searchResults = payload;
		},
		setError: (state, action: PayloadAction<userMessage>) => {
			state.error = action.payload;
		},
		setLoading: (state, { payload }) => {
			state.loading = payload;
		},
		setFilters: (state, { payload }) => {
			state.filters = payload;
		},
		setBeneficiaryDatesRange: (state, { payload }: PayloadAction<IBeneficiaryDashboardDateRange>) => {
			state.beneficiaryDatesRange = payload;
		},
	},
});

export const getSearchResults = (state: any) => {
	return state.dashboard.searchResults;
};
export const getError = (state: any) => {
	return state.dashboard.error;
};
export const isLoading = (state: any) => state.content.loading;
export const getBeneficiaryDatesRange = (state: any) => state.dashboard.beneficiaryDatesRange;
export const {
	setSearchResults,
	setError,
	setLoading,
	setFilters,
	setBeneficiaryDatesRange,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
